import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/footer_logo.png';
// import footerImage from '../assets/images/footer.png';
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn, FaTiktok, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="bg-black pt-20 relative">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black/90" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#C334F6]/5 to-[#543DF4]/5" />
      
      <div className="container mx-auto relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-[64px] font-medium leading-[78px] tracking-[0.002em] font-neue-montreal text-white mb-6">
            <span className="inline-block bg-gradient-to-r from-[#C334F6] to-[#543DF4] bg-clip-text text-transparent">
              Save time and effort
            </span> with<br /> LeadTrek's automated tools.
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Transform your real estate business with our powerful lead generation platform
          </p>
        </div>

        <div className="flex justify-center mb-16">
          <Link 
            to="/contact" 
            className="bg-gradient-to-r from-[#C334F6] to-[#543DF4] text-white px-8 py-4 rounded-full text-lg font-medium inline-flex items-center"
          >
            Contact Us Now
            <span className="ml-3 bg-white rounded-full p-1.5">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="space-y-6">
            <img src={logo} alt="LeadTrek Logo" className="w-[140px] h-[28px]" />
            <p className="font-neue-montreal text-base font-normal leading-[21px] tracking-[0.001em] text-white/80">
              LeadTrek is a powerful tool designed to help real estate agents identify and gather leads from social media platforms.
            </p>
            <div className="flex space-x-4">
              {[
                { Icon: FaFacebookF, url: "https://facebook.com/leadtrek" },
                { Icon: FaInstagram, url: "https://instagram.com/leadtrek" },
                { Icon: FaYoutube, url: "https://youtube.com/leadtrek" },
                { Icon: FaLinkedinIn, url: "https://linkedin.com/company/leadtrek" },
                { Icon: FaTiktok, url: "https://tiktok.com/@leadtrek" },
              ].map(({ Icon, url }, index) => (
                <Link 
                  key={index} 
                  to={url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-r from-[#C334F6] to-[#543DF4]"
                >
                  <Icon className="text-white text-sm" />
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-white/60 font-neue-montreal text-base font-normal leading-[22px] tracking-[0.001em] mb-4">Quick Access</h3>
            <ul className="space-y-3">
              {['Home', 'Product', 'Pricing', 'About Us', 'Blog'].map((item, index) => (
                <li key={index}>
                  <Link 
                    to={item === 'Home' ? '/' : `/${item.toLowerCase().replace(' ', '-')}`} 
                    className="font-neue-montreal text-base font-normal leading-[19.2px] tracking-[0.001em] text-white/80 hover:text-[#C334F6]"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white/60 font-neue-montreal text-base font-normal leading-[22px] tracking-[0.001em] mb-4">Company</h3>
            <ul className="space-y-3">
              {['Contact Us', 'Privacy Policy', 'Terms and Conditions'].map((item, index) => (
                <li key={index}>
                  <Link 
                    to={`/${item.toLowerCase().replace(/ and | /g, '-')}`}
                    className="font-neue-montreal text-base font-normal leading-[19.2px] tracking-[0.001em] text-white/80 hover:text-[#C334F6]"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white/60 font-neue-montreal text-base font-normal leading-[22px] tracking-[0.001em] mb-4">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <FaMapMarkerAlt className="text-[#C334F6] mt-1" />
                <span className="font-neue-montreal text-base font-normal leading-[19.2px] tracking-[0.001em] text-white/80">
                  123 Business Street, Suite 100<br />
                  New York, NY 10001
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <FaPhone className="text-[#C334F6]" />
                <span className="font-neue-montreal text-base font-normal leading-[19.2px] tracking-[0.001em] text-white/80">
                  +1 (555) 123-4567
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <FaEnvelope className="text-[#C334F6]" />
                <span className="font-neue-montreal text-base font-normal leading-[19.2px] tracking-[0.001em] text-white/80">
                  info@leadtrek.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <p className="text-white/60 font-neue-montreal text-sm font-normal leading-[16.8px] tracking-[0.001em] text-center">
            Copyright © {new Date().getFullYear()} LeadTrek. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;